import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="not-found-container">
            <div className="not-found-content">
                <div className="not-found-animation">
                    <div className="error-code">404</div>
                    <div className="error-icon">🔍</div>
                </div>

                <h1 className="not-found-title">Page Not Found</h1>
                <p className="not-found-message">
                    Oops! The page you're looking for doesn't exist or has been moved.
                </p>

                <div className="not-found-actions">
                    <button
                        className="btn-primary"
                        onClick={() => navigate('/')}
                    >
                        🏠 Go to Dashboard
                    </button>
                    <button
                        className="btn-secondary"
                        onClick={() => navigate(-1)}
                    >
                        ← Go Back
                    </button>
                </div>

                <div className="not-found-suggestions">
                    <p className="suggestions-title">You might want to:</p>
                    <ul className="suggestions-list">
                        <li onClick={() => navigate('/goals')}>📋 View Test Goals</li>
                        <li onClick={() => navigate('/apps')}>📱 Browse Apps</li>
                        <li onClick={() => navigate('/execution-plans')}>🎯 Check Execution Plans</li>
                        <li onClick={() => navigate('/settings')}>⚙️ Go to Settings</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
